import React from "react";
import { Container } from "@chakra-ui/react";
import ListNews from "views/admin/News/components/ListNews";

const News = () => {
  return (
    <Container maxW="xxl" mt={100} p={{ base: 4, md: 8 }}>
      <ListNews />
    </Container>
  );
};

export default News;
